export default {
    methods: {
        getData: function () {
            this.$http.get(globalProvider.serviceUrl('e_reg/_cb/p'), {
                    params: this.$route.query
                })
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        this.$confirm('支付成功', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                window.opener = null;
                                window.open('', '_self');
                                window.close();
                            }
                        })
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                });
        }
    },
    created: function () {
        let batchCode = this.$store.state.examInfo.currentExamInfo.batchCode;
        if (this.$route.query) {
            this.getData();
        } else {
            this.$router.push({
                name: batchCode?'batch_main':'main',
                params: {
                    projectCode: store.state.examInfo.currentExamInfo.domain,
                    batchCode:store.state.examInfo.currentExamInfo.batchCode
                },
            })
        }
    }
}